"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceZodError = exports.implement = void 0;
var zod_1 = require("zod");
/**
 * Helper function to implement a declared type as a zod object, enabling
 * validation. Example:
 * `const cMyConst = implement<MyExistingType>().with({...})`
 * where `{...}` is your zod schema declaration.
 */
function implement() {
    return {
        with: function (schema) { return zod_1.z.object(schema); },
    };
}
exports.implement = implement;
function reduceZodError(zodError) {
    return zodError.issues.reduce(function (acc, issue) {
        var path = issue.path.join('.');
        acc[path] = issue;
        delete acc[path].path;
        return acc;
    }, {});
}
exports.reduceZodError = reduceZodError;
